import { PageHero, CTABanner } from "../components/Shared";
import CapabilitiesSection from "../sections/CapabilitiesSection";
import { IMAGES } from "../data/site";

const CapabilitiesPage = () => (
  <main data-testid="capabilities-page">
    <PageHero
      eyebrow="Infrastructure & Capabilities"
      title="Built for Precision. Equipped for Scale."
      description="State-of-the-art infrastructure supported by a highly skilled technical team — from Heidelberg multi-colour offset to specialised finishing."
      image={IMAGES.roller}
    />
    <CapabilitiesSection />
    <CTABanner
      title="Put our production line to work."
      text="From press to finishing to dispatch — one accountable team for your entire job."
    />
  </main>
);

export default CapabilitiesPage;
